module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Home.3bd5c3ef.svg";